export default "__VITE_ASSET__BVmQ2nzx__"